export default __webpack_public_path__ + "static/media/Ballroll_00247.55fd0ada.png";